import React, { PropTypes } from 'react';
// import fetch from 'isomorphic-fetch';
let fetch = require('whatwg-fetch');
import './styles.scss';
import * as URLConstants from '../../constants';

class PlansSection extends React.Component {
  constructor(props) {
    super(props);


    this.state = {
      monthly : false,
      plans   : null,
    };

    this._setBillingToMonthly = this._setBillingToMonthly.bind(this);
    this._setBillingToAnnual = this._setBillingToAnnual.bind(this);
  }

  componentDidMount() {
    this.fetchPlans();
  }

  fetchPlans() {
    window.fetch(`${URLConstants.APIRootURL}/subscriptions`, {
        method: 'get',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          // 'Authorization': store.getState().auth.user.access_token
        },

      })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.errors === undefined) {
          console.info("[Pricing] plans", json.stripe_plans);
          this.setState({plans: json.stripe_plans});
        } else {
          this.setState({errors: json.errors});
        }

        return json;
      }, (error) => {
        console.warn("[Pricing] error", error);
      });
  }

  _setBillingToMonthly() {
    this.setState({monthly: true});
  }

  _setBillingToAnnual() {
    this.setState({monthly: false});
  }

  getPlanDetails(planId) {
    let plan = _.find(this.state.plans, function(p) {
      return p.id == planId;
    });

    return plan;
  }

  render () {
    let individualIcon = "/images/individual-icon.svg",
        teamIcon = "/images/team-icon.svg",
        enterpriseIcon = "/images/enterprise-icon.svg",
        smallPricingMonthly = "49",
        smallPricingYearly  = "42",
        largePricingMonthly = "299",
        largePricingYearly  = "250",
        smallPricing = this.state.monthly ? smallPricingMonthly : smallPricingYearly,
        largePricing = this.state.monthly ? largePricingMonthly : largePricingYearly,
        smallPlanId  = this.state.monthly ? "setter_small_monthly" : "setter_small_yearly",
        largePlanId  = this.state.monthly ? "setter_large_monthly" : "setter_large_yearly",
        smallSignupURL,
        largeSignupURL,
        smallPlanName = this.state.plans && this.getPlanDetails(smallPlanId) ? this.getPlanDetails(smallPlanId).name : null,
        largePlanName = this.state.plans && this.getPlanDetails(largePlanId) ? this.getPlanDetails(largePlanId).name : null;

    smallSignupURL = `${URLConstants.AppRootURL}/register?plan_id=${smallPlanId}&plan_name=${smallPlanName}`,
    largeSignupURL = `${URLConstants.AppRootURL}/register?plan_id=${largePlanId}&plan_name=${largePlanName}`;



    return (
      <div id="pricing" className="PlansSection pricing-cage">
        <h2 className="title text-center">PRICING</h2>

        <div className="SetterBase-spacer-tall"></div>

        <div className="Pricing-monthly-or-annual">
          <button
            className={this.state.monthly ? "active" : ""}
            onClick={this._setBillingToMonthly}>Monthly</button>
          <button
            className={this.state.monthly ? "" : "active"}
            onClick={this._setBillingToAnnual}>Yearly</button>
        </div>

        <div className="SetterBase-spacer-tall"></div>

        <div className="SetterBase-row">
          <div className="SetterBase-medium-center-col SetterBase-large-c-10 SetterBase-col">
            <div className="row">
              <div className="SetterBase-medium-c-4 SetterBase-col">
                <div className="price-card text-center">
                  <h4 className="title">SMALL TEAM</h4>
                  <div className="icon-box"><img src={individualIcon}/></div>
                  <div className="price-box">
                    <h3 className="price">${smallPricing}</h3>
                    <h5 className="per-month"><span className="green-col">/</span> Month</h5>
                  </div>

                  {!this.state.monthly &&
                    <div className="Pricing-billed-annually">Billed annually</div>
                  }

                  <div className="divider"></div>
                  <ul>
                    <li>3 team members</li>
                    <li>Email Support</li>
                    <li>Chrome Plugin</li>
                    <li>2 month Free Trial</li>
                  </ul>
                  <div className="btn-box">
                    <a
                      href={smallSignupURL}
                      className="btn btn-trial">
                        Start your Free Trial
                    </a>
                  </div>
                </div>
              </div>


              <div className="SetterBase-medium-c-4 SetterBase-col">
                <div className="price-card text-center">
                  <h4 className="title">LARGE TEAM</h4>
                  <div className="icon-box"><img src={teamIcon}/></div>
                  <div className="price-box">
                    <h3 className="price">${largePricing}</h3>
                    <h5 className="per-month"><span className="green-col">/</span> Month</h5>
                  </div>

                  {!this.state.monthly &&
                    <div className="Pricing-billed-annually">Billed annually</div>
                  }

                  <div className="divider"></div>
                  <ul>
                    <li>15 team members</li>
                    <li>Phone Support</li>
                    <li>Chrome Plugin</li>
                    <li>2 month Free Trial</li>
                  </ul>
                  <div className="btn-box">
                    <a
                      href={largeSignupURL}
                      className="btn btn-trial">
                        Start your Free Trial
                    </a>
                  </div>
                </div>
              </div>


              <div className="SetterBase-medium-c-4 SetterBase-col">
                <div className="price-card enterprise-card text-center">
                  <h4 className="title">ENTERPRISE</h4>
                  <div className="icon-box"><img src={enterpriseIcon}/></div>
                  <div className="divider"></div>
                  <ul>
                    <li>Unlimited team members</li>
                    <li>Phone support</li>
                    <li>Multiple teams</li>
                    <li>Email Integration</li>
                    <li>2 month Free Trial</li>
                  </ul>
                  <div className="btn-box">
                    <button className="btn btn-trial" onClick={this._openRequestDemoModal}>CONTACT US</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

PlansSection.propTypes = {

};

PlansSection.defaultProps = {

};

export default PlansSection;



/** WEBPACK FOOTER **
 ** ../components/PlansSection/index.js
 **/